import React from "react";
import { PLATFORMS } from "@/lib/mockData";
import { Instagram, Youtube, Twitter, Linkedin, Ghost, Music2 } from "lucide-react";

const iconMap = {
  Instagram: Instagram,
  YouTube: Youtube,
  "Twitter / X": Twitter,
  LinkedIn: Linkedin,
  Snapchat: Ghost,
  TikTok: Music2,
};

const Platforms = () => {
  return (
    <section className="border-y border-white/5 bg-zinc-950/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-zinc-500 mb-8">
          We run campaigns across every platform your audience lives on
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
          {PLATFORMS.map((p) => {
            const Icon = iconMap[p.name] || Instagram;
            return (
              <div
                key={p.name}
                className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/8 bg-white/[0.02] hover:border-blue-500/30 hover:bg-blue-500/5 transition-all"
                data-testid={`platform-badge-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Icon className="h-4 w-4 text-zinc-300" />
                <span className="text-sm text-zinc-200">{p.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Platforms;
